/** The results page of a year that is paused on a card (U1-4, U2-10): a styled card that says why, what to do, and holds the one button. Solo only; a facilitated team waits on its facilitator. */
import type { TeamState } from "@bsim/contracts";
import { categoryWord, severityWord } from "../events/words";
import { Link } from "../shell/history";
import { GxStatusCard } from "../theme/GxStatusCard";

/** The month the year stopped in, from the card that stopped it; null when the team state carries no mid-year card. */
export function pausedMonth(team: TeamState): number | null {
  const card = team.pendingEvents.find((e) => e.timing.phase === "midRound");
  return card !== undefined && card.timing.phase === "midRound" ? card.timing.month : null;
}

export function PausedCard({ team }: { readonly team: TeamState }) {
  const month = pausedMonth(team);
  // The card that is waiting: the mid-year one when there is one, else the first unanswered.
  const waiting = team.pendingEvents.find((e) => e.timing.phase === "midRound") ?? team.pendingEvents.find((e) => e.response === null);
  const named = waiting === undefined ? null : `\u201c${waiting.card.title}\u201d (${categoryWord(waiting.card.category).toLowerCase()}, ${severityWord(waiting.card.severity).toLowerCase()})`;
  return (
    <GxStatusCard icon="pause" testId="results.paused" label="The year is paused for a card" title={named === null ? (month === null ? "Waiting for your answer" : `Paused at month ${month}, waiting for your answer`) : `${named}${month === null ? "" : `, at month ${month}`}`}
      action={<Link href={`/solo/${team.cohort.id}`} className="gx-btn gx-btn--primary" data-testid="results.answer-card">Answer the card →</Link>}>
      Answer it to finish the year.
    </GxStatusCard>
  );
}
